import type { RfqViewState } from "./rfq-view-types";


type Props = Pick<RfqViewState,
  "communications" |
  "governanceBusy" |
  "announcementBody" |
  "setAnnouncementBody" |
  "answerDrafts" |
  "setAnswerDrafts" |
  "publishAnnouncement" |
  "answerQuestion"
>;
export function RfqCommunications({
  communications,
  governanceBusy,
  announcementBody,
  setAnnouncementBody,
  answerDrafts,
  setAnswerDrafts,
  publishAnnouncement,
  answerQuestion,
}: Props) {
  return (
    <section className="rfq-communications" aria-label="Tedarikçi iletişimi">
      <div className="rfq-invitations-heading">
        <div>
          <span className="section-kicker">Tedarikçi iletişimi</span>
          <h3>Soru ve duyurular</h3>
          <p>
            Genel yanıtlar soru sahibini açıklamaz; özel yanıt yalnız
            ilgili davette görünür.
          </p>
        </div>
      </div>
      <div className="rfq-governance-form">
        <label>
          Tüm davetlilere duyuru
          <textarea
            maxLength={4000}
            value={announcementBody}
            onChange={(event) => setAnnouncementBody(event.target.value)}
          />
        </label>
        <button
          className="secondary-button"
          disabled={governanceBusy || announcementBody.trim().length < 2}
          onClick={publishAnnouncement}
        >
          Genel duyuru yayımla
        </button>
      </div>
      <div className="rfq-question-list">
        {communications.questions.map((question) => {
          const draft = answerDrafts[question.id] ?? {
            body: "",
            visibility: "PRIVATE" as const,
          };
          return (
            <article key={question.id}>
              <header>
                <strong>{question.supplierName}</strong>
                <span>{question.status === "ANSWERED" ? "Yanıtlandı" : "Yanıt bekliyor"}</span>
              </header>
              <p>{question.body}</p>
              {question.answer ? (
                <blockquote>{question.answer.body}</blockquote>
              ) : (
                <div className="rfq-question-answer">
                  <label>
                    Yanıt
                    <textarea
                      value={draft.body}
                      onChange={(event) =>
                        setAnswerDrafts((current) => ({
                          ...current,
                          [question.id]: { ...draft, body: event.target.value },
                        }))
                      }
                    />
                  </label>
                  <label>
                    Görünürlük
                    <select
                      value={draft.visibility}
                      onChange={(event) => {
                        const visibility = event.target.value;
                        if (visibility === "ALL_INVITEES" || visibility === "PRIVATE") {
                          setAnswerDrafts((current) => ({
                            ...current,
                            [question.id]: { ...draft, visibility },
                          }));
                        }
                      }}
                    >
                      <option value="PRIVATE">Yalnız soru sahibi</option>
                      <option value="ALL_INVITEES">Tüm davetliler</option>
                    </select>
                  </label>
                  <button
                    className="secondary-button"
                    disabled={governanceBusy || draft.body.trim().length < 2}
                    onClick={() => answerQuestion(question.id)}
                  >
                    Yanıtı kaydet
                  </button>
                </div>
              )}
            </article>
          );
        })}
        {!communications.questions.length ? (
          <p>Henüz tedarikçi sorusu bulunmuyor.</p>
        ) : null}
      </div>
    </section>
  );
}
